import React, { useContext, useState } from "react";
import { Accordion, Form, Grid, Label, Table } from "semantic-ui-react";
import QuestionSet from "../components/QuestionSet";
import { BasicLoadingState } from "../State";
import { handleSubmit, store } from "../store";

const SingleEntityQuestionnaire: React.FunctionComponent = () => {
    const [state, setState] = useState<BasicLoadingState>({ isLoading: false });
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const panels = [
        {
            key: 'questions',
            title: {
                content: <Label size="huge" color="green">Questions? Click <u>here</u> to View our FAQ</Label>,
                icon: <i className="invisible"></i>,
            },
            content: {
                content: (
                    <Table striped unstackable inverted={globalState.state.appState.isDarkTheme}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={8} textAlign="center">QUESTION</Table.HeaderCell>
                                <Table.HeaderCell width={8} textAlign="center">ANSWER</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>Why is the green Submit button not lit?</Table.Cell>
                                <Table.Cell>Please make sure to certify and acknowledge on the portal.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Can I as a producer certify on behalf of the insured?</Table.Cell>
                                <Table.Cell>Yes, but if you are not the producer of record on the current policy, you should attach a letter of authority signed by the insured on the employer's letterhead with your submission.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Why can't I find the name of the insured?</Table.Cell>
                                <Table.Cell>Is the Policy Effective Date correct? If so, you should type the first few characters of the insured's name, the name will populate and you can choose the name of the insured.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>Do I need to fill in all fields?</Table.Cell>
                                <Table.Cell>Yes, all fields with an * must be answered or the submission will not be accepted.</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>What if the total ownership percentage doesn't add up to 100%?</Table.Cell>
                                <Table.Cell>If the total ownership percentage doesn't equal 100%, the submission will not be accepted.</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                ),
            },
        },
    ];

    return (
        <Grid centered className="QuestionSetContainer">
            <Grid.Row>
                <Accordion panels={panels} />
            </Grid.Row>
            <Grid.Row>
                <Form size={"small"} method="post" action="/Index" encType="multipart/form-data">
                    {
                        <QuestionSet isLoading={state.isLoading} icon={state.icon}
                            onSubmit={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSubmit({ state, setState },
                                globalState.state, e, "SEO")}
                            questionAnswers={globalState.state.answerState!} />
                    }
                </Form>
            </Grid.Row>
    </Grid>
  );
};

export default SingleEntityQuestionnaire;